// ContentCard.js
// 移动端信息流卡片：展示标题 + 图片（多图可左右滑动），点击进入详情页
import React, { useRef } from 'react';
import { Carousel } from 'antd';
import { EnvironmentOutlined, ClockCircleOutlined } from '@ant-design/icons';
import './ContentCard.css';

const ContentCard = ({ record, type, onOpen }) => {
  // 记录最近一次有效滑动的时间，用时间窗避免"滑动被当成点击"
  const lastMoveRef = useRef(0);
  const touchRef = useRef(null);

  const images = Array.isArray(record.img_urls)
    ? record.img_urls.filter((url) => url && String(url).trim() !== '')
    : [];

  const handleTouchStart = (event) => {
    const touch = event.touches[0];
    touchRef.current = { x: touch.clientX, y: touch.clientY };
  };

  const handleTouchMove = (event) => {
    if (!touchRef.current) return;
    const touch = event.touches[0];
    if (!touch) return;
    const dx = Math.abs(touch.clientX - touchRef.current.x);
    const dy = Math.abs(touch.clientY - touchRef.current.y);
    if (dx > 8 || dy > 8) {
      lastMoveRef.current = Date.now();
    }
  };

  const handleTouchEnd = () => {
    touchRef.current = null;
  };

  const handleClick = () => {
    // 刚发生过滑动（切换图片/滚动）时，忽略紧随其后的 click
    if (Date.now() - lastMoveRef.current < 350) {
      return;
    }
    if (onOpen) {
      onOpen(record, type);
    }
  };

  const hasPrice =
    record.price !== undefined && record.price !== null && String(record.price).trim() !== '';

  return (
    <div
      className="feed-card"
      onClick={handleClick}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div className="feed-card-title">{record.title || '（无标题）'}</div>

      {images.length > 0 && (
        <div className="feed-card-media">
          {images.length === 1 ? (
            <img
              className="feed-card-single-img"
              src={images[0].trim()}
              alt="图片1"
              loading="lazy"
            />
          ) : (
            <Carousel
              dots
              draggable
              adaptiveHeight={false}
              autoplay
              autoplaySpeed={5000}
              speed={500}
            >
              {images.map((url, index) => (
                <div className="feed-card-slide" key={`slide_${index}`}>
                  <img src={url.trim()} alt={`图片${index + 1}`} loading="lazy" />
                </div>
              ))}
            </Carousel>
          )}
          {images.length > 1 && (
            <span className="feed-card-img-count">{images.length} 张</span>
          )}
        </div>
      )}

      <div className="feed-card-meta">
        {hasPrice && <span className="feed-card-price">￥{record.price}</span>}
        {record.location ? (
          <span>
            <EnvironmentOutlined /> {record.location}
          </span>
        ) : null}
        {record.create_time_text ? (
          <span>
            <ClockCircleOutlined /> {record.create_time_text}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default ContentCard;
